export const typeDefs = `
  union SelfConsumptionRewardSortType = date | platformName | merchantName | orderId | growthReward | consumptionRewardUsd | consumptionReward | totalReward

  input SelfConsumptionRewardFilterInput {
    date: [String]
    platformId: String
    merchantName: String
    orderId: String
    growthReward: [Float]
    consumptionReward: [Float]
    consumptionRewardUsd: [Float]
    totalReward: [Float]
  }

  union MerchantReferralRewardSortType = date | platformName | totalReward | merchantReward | referralReward

  input MerchantReferralRewardFilterInput {
    date: [String]
    platformId: String
    merchantReward: [Float]
    referralReward: [Float]
    totalReward: [Float]
  }

  union CitizenReferralRewardSortType = date | generation | referralReward | percentage

  input CitizenReferralRewardFilterInput {
    date: [String]
    generation: [Float]
    referralReward: [Float]
    percentage: [Float]
  }

  union SuperOrderCommissionsHistorySortType = date | totalReward

  input SuperOrderCommissionsHistoryFilterInput {
    date: [String]
    totalReward: [Float]
  }

  union MegopolyRewardSortType = date | megopolyAmount | trxId

  input MegopolyRewardFilterInput {
    date: [String]
    megopolyAmount: [String]
    trxId: [String]
  }

  union MegopolyOpenMarketSortType = date | megopolyAmount | trxId

  input MegopolyOpenMarketFilterInput {
    date: [String]
    megopolyAmount: [String]
    trxId: [String]
  }
`;
